<template>
    <div class="lender-card">
        <!-- Lender -->
        <div class="card sshadow-lg card-hover-shadow card-bordered" style="border-width: 2px;">
            <div class="card-body">
              <div class="mx-3 mt-2 mb-2">
                <div v-if="hideHeader == null || !hideHeader">
                  <div class="float-right">
                      <span class="badge bg-soft-primary text-secondary" style="font-size: 13pt; text-transform: uppercase; font-weight: bolder">{{ banner }}</span>
                      <span v-if="!isFavourited & false" class="fas fa-shopping-cart text-secondary mx-1"></span>
                      <span v-if="isFavourited" class="fas fa-shopping-cart mx-1 text-success"></span>
                  </div>
                  <div class="card-title" style="text-align: left">
                      <span>
                          <strong>{{ item.lender.lenderName }}</strong>: {{ item.description }}
                      </span>
                  </div>
                </div>
              </div>
              <ul class="product-card">
                <li v-if="!isSelectedLender">
                  <a :href="item.lender.mortgagesUrl" target="_new"><img :src="item.lender.imageUrl" :title="item.lender.lenderName" :alt="item.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </li>
                <li>
                  <span class="text-secondary font-size-1 d-block">{{ (item.isFixedProduct || item.isDiscountProduct) ? "Initial Rate" : "Rate" }}</span>
                  <div class="font-size-2 strong">
                    {{ (item.isFixedProduct ? item.initialInterestRate : item.interestRate) | prettyInterestRate }}
                  </div>
                </li>
                <li>
                  <span class="text-secondary font-size-1 d-block">APRC</span>
                  <div class="font-size-2 strong">
                    {{ item.calculations.aprc | prettyInterestRate }}
                  </div>
                </li>
                <li>
                  <div class="font-size-2">
                    <span class="text-secondary font-size-1">Fees</span><br />
                    {{ item.fees.arrangementFee | prettyMoney }}
                  </div>
                </li>
                <li v-if="!hideMonthlyCost">
                  <div class="font-size-2">
                    <span class="text-secondary font-size-1">£ Monthly Payment</span><br />
                    <span :class="monthlyCostStyle">
                        {{(item.isFixedProduct ? item.calculations.initialMonthlyCost : item.calculations.regularMonthlyCost) | prettyMoney }}
                        <span v-if="monthlyCostIcon" :class="monthlyCostIcon"></span>
                      </span>
                  </div>
                </li>
                <li v-if="!hideLtv">
                  <div class="font-size-2">
                    <span class="text-secondary font-size-1">Maximum LTV</span><br />
                    <span>
                        {{ (item.ltvMaxPercent/100) | prettyPercent }}
                      </span>
                  </div>
                </li>
                <li v-if="previewMode == null || !previewMode">
                  <div v-if="showDetails" class="w-90 btn-group btn-group-toggle" data-toggle="buttons">
                    <button class="btn btn-sm btn-soft-secondary" title="Hide details" @click="showDetails = false">Hide</button>
                    <button v-if="!isFavourited" class="btn btn-soft-success btn-sm btn-icon" @click="addToBasket()" title="Add to Basket"><i class="fas fa-shopping-cart"></i></button>
                    <button v-if="isFavourited" class="btn btn-soft-danger btn-sm btn-icon" @click="removeFromBasket()" title="Remove from Basket"><i class="fas fa-trash-alt"></i></button>
                  </div>
                  <button v-if="!showDetails" class="btn btn-soft-success w-90 btn-sm" @click="showDetails = true">More Details</button>
                </li>
              </ul>
              <transition name="fade-in-up">
                <ProductCardDetails v-if="showDetails" :item="item" :query="query" @closed="showDetails = false"></ProductCardDetails>
              </transition>
              <div class="text-center mb-2">
                  <span v-if="showDetails && !previewMode" class="divider divider-text">
                    <button class="btn btn-sm btn-ghost-primary" @click="showDetails = false">Hide Details</button>
                  </span>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    import ProductCardDetails from "@/components/products/ProductCardDetails";
    import { mapActions, mapGetters } from "vuex";
    
    export default {
        name: "ProductCard",
      
        data() {
          return {
            showDetails: false
          }
        },
      
        components: {
          ProductCardDetails
        },
        
        mounted() {
          this.showDetails = this.previewMode != null ? this.previewMode : false;
        },
      
        props: {
            item: Object,
            monthlyComparison: Number,
            query: Object,
            hideHeader: Boolean,
            hideMonthlyCost: Boolean,
            hideLtv: {
              type: Boolean,
              default: true
            },
            previewMode: Boolean,
            banner: String
        },
      
        methods: {
            ...mapActions([
                "addProductToBasket",
                "removeProductFromBasket"
            ]),
          
            addToBasket() {
              this.addProductToBasket(this.item);
            },
          
            removeFromBasket() {
              this.removeProductFromBasket(this.item);
              this.showDetails = false;
            }
        },
        
        computed: {
            ...mapGetters([
              "shoppingBasket"
            ]),
          
            monthlyCostIcon() {
              return this.monthlyDifference === 0 ? null :
                  this.monthlyDifference < 0 ? "fa fa-xxs fa-caret-up" : "fa fa-xxs fa-caret-down";
            },
            monthlyCostStyle() {
              return this.monthlyDifference === 0 ? null :
                  this.monthlyDifference < 0 ? "text-danger" : "text-success";
            },
          
            monthlyDifference() {
              return this.monthlyComparison == null ? 0 : this.monthlyComparison - (this.item.isFixedProduct ? this.item.calculations.initialMonthlyCost : this.item.calculations.regularMonthlyCost)
            },
          
            isFavourited() {
                return this.shoppingBasket.find(b => b.uid === this.item.uid);
            },
            
            isSelectedLender() {
                return false;
            }
        }
    }
</script>

<style scoped>
    .product-card {
      display: table;      /* Required for table-cell to work on li's */
      padding: 0;          /* Override defaults for lists */
      margin: 5px;           /* Override defaults for lists */
      width: 100%;         /* Get the row full width */
      text-align: center;  /* Centre align grid items */
    }
    
    .product-card li {
      display: table-cell;   /* Get all images to show in a row */
      text-align: center;    /* Centre align the images */
      align-items: center;
      width: 15%;
      margin-top: 3px;
      margin-bottom: 12px;
      vertical-align: middle;
      border-right: solid 1px #e0e0e0;
    }
    
    .product-card li:hover {
    }
    
    .product-card li:last-child {
      border-right: none;
    }
    
    @media (max-width: 960px) and (min-width: 501px) {
      .product-card li { width: 50%; } /* Show 2 logos per row on medium devices (tablets, phones in landscape) */
    }
    
    @media (max-width: 500px) {
      .product-card li { width: 50%; } /* On small screens, show one logo per row */
    }
    
    @media (max-width: 960px) {
      .product-card {
        display: block;
      }
    
      .product-card li {
        display: inline-block;
      }
    }

    div.card-stat {
        border-left: 1px solid #e0e0e0;
        line-height: 1.6rem;
        padding-bottom: 12px;
    }
    
    .card-body {
        padding: 0.25rem !important;
    }
</style>